import Styled from 'styled-components';

export const Container = Styled.div`
  margin: 6%;
  font-family: var(--font-family-base);

  .resume-title {
    color: var(--title-color);
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 24px;
  }

  .label {
    color: var(--title-color);
    font-size: 17px;
    margin-bottom: 12px;
    display: block;
    font-weight: 600;
  }
`;

export const Line = Styled.div`
  border-bottom: 1px solid #C6C6C5;
  margin: 25px 0 20px;
`;

export const SummaryBox = Styled.div`
  background-color: #F0F0F0;
  padding: 20px;
  margin-top: 20px;
  border-radius: 8px;
  font-family: var(--font-family-base);

  .title-summary {
    color: var(--title-color);
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 16px;
  }

  .item-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .item-label {
    color: var(--text-color);
    font-size: 15px;
  }

  .dots {
    flex: 1;
    border-bottom: 1px dashed #818181;
    margin: 0 10px;
  }

  .item-value {
    color: var(--text-color);
    font-size: 14px;
    font-weight: 500;
    opacity: 0.8;
  }

  .total-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #C6C6C5;
  }

  .total-label {
    color: var(--title-color);
    font-weight: 700;
    font-size: 18px;
  }

  .total-value {
    color: var(--primary-color);
    font-weight: 700;
    font-size: 18px;
  }
`;

export const FormContainer = Styled.div`
  .passenger-block {
    margin-bottom: 30px;
    padding: 20px;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
  }

  .error-message {
    color: #D32F2F;
    font-size: 12px;
    margin-top: 4px;
  }
`;
